export default __webpack_public_path__ + "static/media/im1.2840e419.png";